<template>
  <q-card style="width: 800px; max-width: 250vw;">
    <q-table
      :data="purchaseDetail.PurchaseList"
      :columns="columns"
      row-key="name"
      :pagination.sync="tableSet"
    >
    <template v-slot:top="props">
      <div class="col-3 q-table__title">選擇付款列表</div>
      <q-radio v-model="payForm.type" :val="1" label="匯款" />
      <q-radio v-model="payForm.type" :val="2" label="支票" style="margin-right:5px;"/>
      <q-radio v-model="payForm.type" :val="3" label="現金" style="margin-right:5px;"/>
      <q-input v-model="payForm.note" label="備註" style="color: white;"/>
      <q-btn
        color="green"
        icon="near_me"
        label="確定付款"
        style="margin-right:5px;"
        @click="handleConfirmPay"
      ></q-btn>
      <q-btn label="取消" color="red" v-close-popup />
      <div class="text-h6">採購單: {{ purchaseDetail.purchase_no }} 總和: {{ payForm.payTotal }}</div>
    </template>
    <template v-slot:body="props">
      <q-tr :props="props">
      <q-td key="title" :props="props">{{ props.row.detail.title }}</q-td>
      <q-td key="nickName" :props="props">{{ props.row.detail.nick_name }}</q-td>
      <q-td key="buy" :props="props">{{ props.row.buy }}</q-td>
      <q-td key="price" :props="props">{{ props.row.answer_price }}</q-td>
      <q-td key="total" :props="props">{{ props.row.row_total }}</q-td>
      </q-tr>
    </template>
    </q-table>
  </q-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { PriceFormat } from "@/utils";
  export default {
    name: "PurchasePayList",
    props: {
      isShow: {
        type: Boolean,
        default: false
      },
      selectList: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        payForm: {
          payTotal: 0,
          type: 1,
          note: '',
          list: []
        },
        columns: [
          { name: 'title', align: 'center', label: '產品名稱', field: 'title'},
          { name: 'nickName', label: '物料暱稱', field: 'nick_name'},
          { name: 'buy', label: '購買數量', field: 'safe_stock'},
          { name: 'price', label: '價格'},
          { name: 'total', label: '總和'}
        ],
        tableSet: {
          sortBy: 'desc',
          descending: false,
          page: 1,
          rowsPerPage: 10
        }
      }
    },
    computed: {
      ...mapGetters(['purchaseDetail', 'paymentStatus', 'purchasePayID'])
    },
    created(){
      this.$store.dispatch('purchaseGetLocalDetail', this.purchasePayID).then(res =>{
        this.purchaseDetail.PurchaseList.map(r =>{
          this.payForm.payTotal += r.answer_price * r.buy
        })
        this.payForm.payTotal = this.purchaseDetail.Paytotal
      })
    },
    methods: {
      handleConfirmPay() {
        this.$q.dialog({
          dark: true,
          title: '確認！',
          message: '是否確認送出付款資訊？',
          cancel: true,
          persistent: true
        }).onOk(() => {
          this.purchaseDetail.status = 2
        //   this.payForm.list = this.selectList
          this.$store.dispatch('purchaseSendPayCreate', this.payForm)

        //   this.$emit('updateSelectPayStatus')
        })
      },
    }
  }
</script>

<style scoped>
  .image {
    max-width: 110px;
    height: auto;
  }
</style>
